import NewForgotPassword, { ForgotPasswordProps } from 'ui/authentication/forgot-password';

export type Props = {
  data: ForgotPasswordProps;
};

const AccountForgotPasswordTastic = ({ data }: Props) => {
  return <NewForgotPassword {...data} />;
};

export default AccountForgotPasswordTastic;
